import { useRef, useState } from "react";
import AlertComponent from "./AlertComponent";
import { uploadImagem } from "../services/uploadService";

const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];

export default function ImageSourceField({
  label,
  value,
  onChange,
  categoria,
  placeholder = "https://...",
  disabled = false,
  helpText,
  removeText = "Remover imagem",
}) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  async function handleFileChange(event) {
    const arquivo = event.target.files?.[0];
    if (!arquivo) return;

    if (!IMAGE_TYPES.includes(arquivo.type)) {
      AlertComponent("Formato inválido", "Use uma imagem JPG, PNG, WEBP ou GIF", { icon: "warning" });
      event.target.value = "";
      return;
    }

    setUploading(true);
    try {
      const uploaded = await uploadImagem(categoria, arquivo);
      onChange(uploaded.url);
      AlertComponent("Imagem enviada", "A imagem foi vinculada ao campo.", { icon: "success", timer: 1600 });
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || err.response?.data?.message || "Erro ao enviar imagem", { icon: "error" });
    } finally {
      setUploading(false);
      event.target.value = "";
    }
  }

  return (
    <div>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}

      <div className="flex flex-col gap-2">
        <input
          type="url"
          value={value || ""}
          onChange={(event) => onChange(event.target.value)}
          className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
          placeholder={placeholder}
          disabled={disabled || uploading}
        />

        <div className="flex flex-wrap items-center gap-2">
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            onChange={handleFileChange}
            className="hidden"
            disabled={disabled || uploading}
          />
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={disabled || uploading}
            className="px-3 py-2 text-sm font-medium rounded-md border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 disabled:opacity-60"
          >
            {uploading ? "Enviando..." : "Subir imagem"}
          </button>
          {value && (
            <button
              type="button"
              onClick={() => onChange("")}
              disabled={disabled || uploading}
              className="px-3 py-2 text-sm font-medium rounded-md border border-red-100 text-red-600 hover:bg-red-50 disabled:opacity-60"
            >
              {removeText}
            </button>
          )}
        </div>
      </div>

      {helpText && <p className="text-xs text-slate-400 mt-1">{helpText}</p>}

      {value && (
        <div className="mt-3 overflow-hidden rounded-lg border border-slate-200 bg-slate-50">
          <img src={value} alt="" className="h-36 w-full object-cover" />
        </div>
      )}
    </div>
  );
}
